// extracted by mini-css-extract-plugin
export default {"base":"Footer_base__PVepH","buttons":"Footer_buttons__Tf8yE","buttonsCell":"Footer_buttonsCell__bycTf"};